// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"85395f8d","337":"035b253e","453":"9ea90f13","455":"155a9125"}[chunkId] + ".chunk.js";
};